import { doc, setDoc, getDoc, collection } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "./firebase";

export async function submitChronoScore({
  dateKey,
  guesses,
  chronoscore,
  events,
}) {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    const guestName = localStorage.getItem("displayName");
    const guestUid = localStorage.getItem("guestUid");

    const uid = user?.uid || guestUid || `guest_${Date.now()}`;
    const displayName = user?.displayName || guestName || "guest";
    const type = user ? "user" : "guest";

    const safeScore = typeof chronoscore === "number" ? chronoscore : 0;
    const safeGuesses = typeof guesses === "number" && guesses > 0 ? guesses : 5;

    const entry = {
      name: displayName,
      type,
      score: safeScore,
      numGuesses: safeGuesses,
      events: events.map((e) => ({
        event: e.event,
        guess: e.guess,
        actual: e.actual ?? e.year ?? null,
        points: e.points ?? 0,
      })),
      timestamp: Date.now(),
      userId: uid,
    };

    // Check if the user or guest has already played today
    const userPlayedRef = user
      ? doc(db, "users", user.uid, "playedToday", dateKey)
      : doc(db, "guests", guestUid, "playedToday", dateKey); // For guests, store in "guests" collection

    const userPlayedSnap = await getDoc(userPlayedRef);

    if (userPlayedSnap.exists()) {
      // If they have already played today, throw an error or return early
      throw new Error("You’ve already played today!");
    }

    // Store the "played today" flag in Firebase for that day
    await setDoc(userPlayedRef, { playedToday: true });

    // Save to leaderboard (1 play per day)
    const playersRef = collection(db, "leaderboards", dateKey, "players");
    await setDoc(doc(playersRef, uid), entry);

    // Save to user profile (if logged in)
    if (user?.uid) {
      const userDoc = doc(db, "users", user.uid, "scores", dateKey);
      await setDoc(userDoc, entry);

      const userMainDoc = doc(db, "users", user.uid);
      const userMainSnap = await getDoc(userMainDoc);
      const stats = userMainSnap.exists() ? userMainSnap.data().stats || {} : {};

      const totalGames = (stats.totalGames || 0) + 1;
      const totalGuesses = (stats.totalGuesses || 0) + safeGuesses;
      const totalScore = (stats.averageScore || 0) * (stats.totalGames || 0) + safeScore;
      const averageScoreAllTime = Math.round((totalScore / totalGames) * 10) / 10;

      const updatedStats = {
        totalGames,
        totalGuesses,
        averageScore: averageScoreAllTime,
        bestScore: Math.max(stats.bestScore || 0, safeScore),
      };

      await setDoc(userMainDoc, {
        chronoscore: safeScore,
        lastPlayed: dateKey,
        stats: updatedStats,
      }, { merge: true });
    }

  } catch (error) {
    console.error("🔥 Failed to submit score:", error);
    throw error;
  }
}
